import { Fragment } from 'react'
import Link from 'next/link'
import { Disclosure } from '@headlessui/react'
import { MdKeyboardArrowDown } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { getFilters, setFilters } from '@/store/slices/speakersSlice'
import { Popover, Transition } from '@headlessui/react'
import { BsChevronDown } from 'react-icons/bs'
import classNames from 'classnames'
import styles from '@/styles/components/navbar.module.scss'
import Loader from '@/components/common/Loader'
import MobileSearch from './MobileSearch'

const CategoriesMobileView = ({ categories, isLoading, isError, onParentCategoryClick }) => {
  const dispatch = useDispatch()
  const filters = useSelector(getFilters)

  const show = () => {
    if (typeof document !== 'undefined') document.querySelector('body').style.overflow = 'auto'
  }
  const hide = () => {
    if (typeof document !== 'undefined') document.querySelector('body').style.overflow = 'hidden'
  }

  return (
    <div>
      <Popover>
        {({ open }) => (
          <>
            {open ? hide() : show()}
            <Popover.Button
              className={
                open ? 'flex items-center outline-none' : 'flex items-center focus:outline-1'
              }
              onClick={() => (document.querySelector('body').style.overflow = 'hidden')}
            >
              <span className="tagline-font text-sm tracking-wider">Categories</span>
              <BsChevronDown
                className={`${
                  open
                    ? 'rotate-180 transform h-3.5 w-4 text-white ml-2'
                    : 'h-3.5 w-4 text-white ml-2'
                }`}
              />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-400"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-90 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-90 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <div
                className={classNames(
                  styles.footerImg,
                  'z-[21474836461] h-screen  opacity-95 absolute inset-x-1/2 bg-black w-[101vw] mx-[-50vw] mt-5 md:mt-6 pt-6 bg-no-repeat bg-bottom bg-contain overflow-auto md:pb-14 pb-36'
                )}
              >
                <Popover.Panel className="uta-container">
                  {({ close }) => (
                    <>
                      {
                        <>
                          {isLoading || isError ? (
                            <Loader isNavBar={true} />
                          ) : (
                            <>
                              <div className="bg-cover md:hidden">
                                <MobileSearch close={close} />
                                {categories?.map((item, index) => (
                                  <div className="w-full px-4 outline-none" key={index}>
                                    <div>
                                      <Disclosure>
                                        {({ open }) => (
                                          <>
                                            <Disclosure.Button className="flex items-center text-left px-4 text-base font-extrabold tagline-font text-white leading-6 py-6 w-full justify-between focus:outline-none tracking-wider">
                                              <h2
                                                className="cursor-pointer"
                                                onClick={() => {
                                                  onParentCategoryClick(item)
                                                  close()
                                                }}
                                              >
                                                {item.category.toUpperCase()}
                                              </h2>
                                              <MdKeyboardArrowDown
                                                className={`${
                                                  open
                                                    ? 'mt-1 rotate-180 transform h-6 w-6'
                                                    : 'text-white mt-1 h-6 w-6'
                                                }`}
                                              />
                                            </Disclosure.Button>
                                            <Disclosure.Panel className="text-gray-500 overflow-auto">
                                              <nav className="list-none mb-7">
                                                {item.subCategories.map((subCategory, i) => (
                                                  <li key={i}>
                                                    <Link
                                                      href={`/speakers/topics/${subCategory?.slug}`}
                                                      legacyBehavior
                                                    >
                                                      <a
                                                        className="text-[#B4B4B4] text-sm px-4 font-normal regular-font leading-9 tracking-wider hover:text-white"
                                                        onClick={() => {
                                                          dispatch(
                                                            setFilters({
                                                              ...filters,
                                                              categories: [subCategory?.id],
                                                              searchQuery: '',
                                                              types: null,
                                                              profileCategory: null,
                                                              relatedSpeakers: null,
                                                              sortOrder: null,
                                                            })
                                                          )
                                                          close()
                                                        }}
                                                      >
                                                        {subCategory.name}
                                                      </a>
                                                    </Link>
                                                  </li>
                                                ))}
                                              </nav>
                                            </Disclosure.Panel>
                                            <div className="md:w-full border-t b border-custom-gray-80 px-4"></div>
                                          </>
                                        )}
                                      </Disclosure>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                        </>
                      }
                    </>
                  )}
                </Popover.Panel>
              </div>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  )
}

export default CategoriesMobileView
